const accessTokenCookieName = 'plej-cms-access-token'
const userDataName = 'plej-cms-user-data'

export {
  accessTokenCookieName,
  userDataName
}
